import { render, staticRenderFns } from "./editDesktopDot.vue?vue&type=template&id=5403d5a0&scoped=true&"
import script from "./editDesktopDot.vue?vue&type=script&lang=js&"
export * from "./editDesktopDot.vue?vue&type=script&lang=js&"
import style0 from "./editDesktopDot.vue?vue&type=style&index=0&id=5403d5a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403d5a0",
  null
  
)

export default component.exports